<template>
    <div>
        <div class="breadcrumb-layout" name="head-block">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>配件使用情况</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" :selectComId="skipComId" :enableSearch="true" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-block">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="downLoadAccIoRecordList()">
                    <span>导出</span>
                </button>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { openWorkVoucherDetailDlg } from '../workVoucher/showDetailDlg'
    //
    import shareAccApi from '../../api/shareAcc'
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    import userApi from '../../api/user'

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    export default {
        name: 'swb-share-acc-io-record-list',
        path: '/share/acc/useturn/voucher/item/list/get',
        avlActions: '',
        desc: '配件使用情况',
        data: function () {
            return {
                confKey: "swb-share-acc-io-record-list",
                queryOnLoad: true,
                tableHeight: 300, //表格高度
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                ioRecordList: [],
                ioFlagMap: {},
                vendorTypeMap: {},
                accId: null,
                warehouseId: null,
                //
                treeCollapse: true,
                comInfo: {},
                thisBizUnitId: null,
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                level: null,
                exportParmas: null,
                skipComId: null,
                lastPageNumber: null,
                scopeEntity: null,
                mgmtSmlAreaId: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            this.accId = this.$route.query.accId || null;
            this.warehouseId = this.$route.query.warehouseId || null;
            // this.$route.query.includeSubComs || null;
            let currentComInfo = this.$route.query.currentComInfo || null;
            //
            if(!Utils.isNoB(currentComInfo) && !Utils.isNoB(currentComInfo.id)) {
                //
                this.skipComId = currentComInfo.id;
                this.includeSubComs = currentComInfo.includeSubComs;
                //
                this.notityChange(currentComInfo);
            }
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    self.scopeEntity = result.data.scopeEntity;
                }
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="head-block"],[name="tree-block"],[name="query-sort-block"],[name="btn-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'price': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'custVoucherNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return '<a name="view_detail" class="table-cell-link">' + colValue + '</a>';
                        }
                        return '';
                    },
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'custVoucherNo': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view_detail') {
                            openWorkVoucherDetailDlg(null, row.custVoucherNo);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            //
            notityChange: function (eventData) {
                this.mgmtSmlAreaId = null;
                if(Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.thisComLevel = scopeEntity.comLevel;
                    this.thisComId = scopeEntity.comId;
                    this.thisBizUnitId = scopeEntity.bizUnitId;
                    this.includeSubComs = true;
                    this.mgmtSmlAreaId = eventData.id;
                } else {
                    if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                        this.thisComLevel = eventData.level;
                        this.thisComId = eventData.id;
                        this.thisBizUnitId = eventData.bizUnitId;
                        this.level = eventData.level;
                        this.includeSubComs = eventData.includeSubComs;
                        this.pageNumber = 1;
                    }
                }
                this.getIoRecordList();
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //缓存查询条件
                this.getIoRecordList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getIoRecordList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getIoRecordList();
            },
            getIoRecordList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                // 其他界面跳转来的 单据id
                if(!Utils.isNoB(self.accId)) {
                    filterItems.accId = self.accId;
                }
                if(!Utils.isNoB(self.warehouseId)) {
                    filterItems.warehouseId = self.warehouseId;
                }
                filterItems.custComId = self.thisBizUnitId;
                filterItems.comLevel = self.thisComLevel;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                self.exportParmas = filterItems;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                shareAccApi.getShareAccUseturnVoucherItemList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        self.ioRecordList = data.rows;
                        self.totalCount = data.pagination.totalCount;
                        self.renderTable(result.data.rows, data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            downLoadAccIoRecordList: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(this.totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let pages = Math.ceil(this.totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "配件使用情况" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '配件使用情况-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/share/acc/useturn/voucher/item/list/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/UseturnVoucherItemList.vue